exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dropdown-box{display:block}.dropdown-box select{display:block;width:100%;height:50px;white-space:nowrap;overflow:hidden;background-color:#4183b6;background-image:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgi…pZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JhZCkiIC8+PC9zdmc+IA==\");background-size:100%;background-image:linear-gradient(180deg,#4e9de1,#4183b6);border:0 none;padding:10px 37px 10px 20px;-webkit-appearance:button;-moz-appearance:button;appearance:button;position:relative;border-radius:0;color:#fff;margin:0}.lt-ie10 .dropdown-box select{background-image:none;color:#000;padding:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./js-src/markdown-editor/modules/dropdown/dropdown.styl
// module id = 73
// module chunks = 0 1